// extracted by mini-css-extract-plugin
export default {"listItem":"SectionListItem-module__listItem__F7RhBge"};